<template>
    <b-overlay :show="showoverlay" rounded="sm">
        <div class="row">
            <div class="col-md-10 col-sm-12" >
                <h4 class="atlhr-dashboard-title mt-10">Loan / Advance Dashboard<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Loan / Advance Dashboard</span></h4>
            </div>
        </div>
        
        <div class="card mt-5 border-0 bg-wash no-shadow">
        
            <div class="card-header px-0 bg-transparent border-0">
                    <div class="col-12 text-right pr-0"><b-button  class="mb-1 w-100" @click="addNew()" style="max-width: 325px;"><i class="fas fa-plus mr-2"></i>Add New Loan/Advance</b-button></div>
            </div>

            <common-list  :checkbox="checkbox" :is_action="is_action" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="employees" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list>       
            
            <b-modal id="bv-modal-loan" size="lg" hide-footer v-bind:title="modal_title">
                <loan-form  :flg="0" :employee_id="this.em_id" :key="count" :count="count" :loan_id="0" :is_custom="0" v-on:childToParent="updateTransactions"></loan-form> 
            </b-modal>

            <b-modal id="bv-modal-employee" size="lg" hide-footer v-bind:title="modal_title">
                <loan-search-employee  v-on:childToParent="setEmployee"></loan-search-employee>
            </b-modal>

        </div>
    </b-overlay>
</template>


<script>
    export default{
        props: [],        
        
        data(){
            return {
                
                cu:window.location.href,
                ce:false,
                showoverlaymodal : false,
                tmp_employees:[],
                /**Child Component property data */
                is_action:1,
                checkbox:0, 
                list_key:0,
                employees : [],                
                default_column:['name','phone','email','jobposition','department','branch'],
                appended_column:[],
                primary_key:'employee_id', 
                company_options:[],
                /***Child Component property data */            
                modal_title: '',
                company_id_title : '',
                amount_title: '',
                deduction_start_month_title:'',
                effective_date_title :'',
                status_title : '',
                details_title: '',
                count:0,
                selected: [],
                showoverlay : true,
                viewmode :true,
                people:0,
                
                em_id:0,

            }
        },
        methods:{
            showLoanDetails: function(x)
            {  
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                let currentObj = this;
                let formData = new FormData();
                formData.append('employee_id', x);
                axios.post(this.$api_url+'/loan-advance/setemployee', formData)
                    .then(function (response) 
                    {    
                        this.showoverlay = false;
                        window.location.href = this.$api_url+'/loan-advance/info';
                        
                    }.bind(this))
                    .catch(function (error) 
                    { 
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });

            },
            getEmployees: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                let currentObj = this;
                axios.get(this.$api_url+'/employee/list' , {

                    }).then(function(response){
                        
                        this.showoverlay = false;
                        if(response.data.error == 1)
                            this.notice = response.data.notice;
                        else
                        {
                            this.tmp_employees = response.data.employee_data;
                            if(this.tmp_employees.length > 0 )
                            {
                                this.tmp_employees.forEach(element => {
                                    if(element.employee_id > 0)
                                    {
                                        let dop = []; 
                                        dop = dop.concat([{ label: 'Initiate Loan / Advance' , value: 1 }]);
                                        dop = dop.concat([{ label: 'Loan / Advance Profile' , value: 2 }]);

                                        element.actions = dop;
                                    }
                                    });
                                
                                this.employees = this.tmp_employees;
                            }
                            
                            this.company_options = response.data.options;
                            this.list_key = this.list_key + 1;

                        }

                        }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});
            },
            listReturn:function(data)
            {
                if(data.selected.length > 0)
                {
                    this.selected = data.selected;
                }
                else
                {
                    this.selected = [];
                    if(data.employee_id > 0)
                    {
                        if(data.action_id == 0 || data.action_id == 2)
                        {
                            this.showLoanDetails(data.employee_id);
                        }
                        else
                        {
                            this.showProcessModal(data.employee_id);
                        }
                        //this.editEmployee(data.employee_id,0);
                    }

                }
            },   
            updateTransactions(x)
            {
                if(!this.checkNet()) return false;
                let currentObj = this; 
                
                axios.get(this.$api_url+'/loan-advance/updatetransactions', {
                    params: {
                        loan_type: 1
                    }
                }).then(function(response){
                    this.$bvModal.hide('bv-modal-loan');
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
                
            },
            showProcessModal: function(x)
            {
                this.em_id = x;
                this.count = this.count + 1;
                this.modal_title = "Add Loan/Advance";
                this.$bvModal.show('bv-modal-loan');
            },
            getAcl: function()
            {
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;                    
                }.bind(this));
            },            
            
            setEmployee: function(emplyee_id)
            {
                this.em_id = emplyee_id;
                this.count = this.count + 1;
                this.modal_title = "Select Employee";
                this.$bvModal.hide('bv-modal-employee');
                this.$bvModal.show('bv-modal-loan');
            },
            addNew: function()
            {
                this.$bvModal.show('bv-modal-employee');
            },
             
        
        },
        
        created: function(){
            $(window).on('load', function (e) {
                setTimeout(function(){
                    $('.div1').width($('table.employee-list-table').width());
                    $('.div2').width($('table.employee-list-table').width());
                    if($('table.employee-list-table').width() > $('.wrapper1').width()){
                        //alert($('table.employee-list-table').width());
                        $('.wrapper1').show();
                    }else{
                        //alert('Its not bigger');
                        $('.wrapper1').hide();
                    }
                }, 2000);
                $('.wrapper1').on('scroll', function (e) {
                    $('.wrapper2').scrollLeft($('.wrapper1').scrollLeft());
                }); 
                $('.wrapper2').on('scroll', function (e) {
                    $('.wrapper1').scrollLeft($('.wrapper2').scrollLeft());
                });
                
                //$('.trz-custom-dropdown .custom-switch input').click(function(){
                $(document).on("click",".trz-custom-dropdown .custom-switch input",function() {
                    setTimeout(function(){
                        $('.div1').width($('table.employee-list-table').width());
                        $('.div2').width($('table.employee-list-table').width());
                        if($('table.employee-list-table').width() > $('.wrapper1').width()){
                            $('.wrapper1').show();
                        }else{
                            $('.wrapper1').hide();
                        }
                    }, 500);
                });
            });
            
            if(this.$cookies.isKey("column_selected"))
            {
                if(this.$cookies.get("column_selected") != null && this.$cookies.get("column_selected") != '') 
                    this.column_selected = this.$cookies.get("column_selected").split(',');
            }

            this.getAcl();            
            this.getEmployees();
            this.updateTransactions(1);
        }
    
    }
</script>
<style>
button.disabled{
    cursor: default;
}

</style> 